export default "__VITE_ASSET__Qzwd$3kK__"